<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/mixins";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/colors";

  .verbose-information {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: utils.in_rem(16px);
    padding: utils.in_rem(24px) 0;

    @media (max-width: 740px) {
      grid-template-columns: repeat(2, 1fr);
    }

    @media (max-width: 500px) {
      grid-template-columns: repeat(1, 1fr);
    }
  }

  .info-row {
    display: flex;
    flex-direction: column;
    gap: utils.in_rem(4px);
  }

  .label {
    @include mixins.title3();
    color: colors.get("textDisabledGrey");
    text-transform: uppercase;
  }

  .value {
    @include mixins.body2();
  }
</style>

<script>
  import TruncatedText from "@sourcewhale/shared/svelte-design-system/components/utils/TruncatedText.svelte";

  export let item; // company data object
  export let MAP; // contains keys and corresponding labels to be shown

  // Only attempt to truncate the following keys (which correspond to lists of items)
  const KEYS_TO_TRUNCATE = ["industries", "contractTypes"];
</script>

{#if item}
  <div class="verbose-information">
    {#each Object.keys(MAP) as key}
      <!-- Don't show the key if it is an empty array or falsy -->
      {#if item[key] && (Array.isArray(item[key]) ? item[key].length : item[key])}
        <div class="info-row">
          <div class="label">
            {MAP[key].tooltip}
          </div>
          {#if KEYS_TO_TRUNCATE.includes(key)}
            <div class="value">
              <TruncatedText text={item[key]} limit="20" />
            </div>
          {:else}
            <div class="value">
              {item[key]}
            </div>
          {/if}
        </div>
      {/if}
    {/each}
  </div>
{/if}
